import React, { useEffect, useState } from "react";
import { Modal, Button, Dropdown } from "react-bootstrap";
import "./ViewMembersList.scss";
import _ from "lodash";
const ViewMembersList = (props) => {

  const { 
    membersModal, setMembersModal, membersList,
    setMembersList, selectedParticipantId, 
    setSelectedParticipantId, participantChips, setParticipantChips,
    participantIds
  } = props

  const [selectedRows, setSelectedRows] = useState([]);
  const [selectedParticipants, setSelectedParticipants] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [mList, setMList] = useState([]);


  useEffect(() => {
    if (!_.isEmpty(participantIds)) {
      setSelectedRows(participantIds)
    }
  }, [participantIds])

  useEffect(() => {
    if (!_.isEmpty(membersList)) {
      setMList(membersList);
    }
  }, [membersList])

  useEffect(() => {
    if (searchText) {
      setMList(mList.filter((row) => {
        if (row.first_name.toLowerCase().includes(searchText.toLowerCase()) ||
        row.middle_name.toLowerCase().includes(searchText.toLowerCase()) ||
        row.last_name.toLowerCase().includes(searchText.toLowerCase()) ||
        row.email.toLowerCase().includes(searchText.toLowerCase())
        ) {
          return true;
        }
      }));
    }
  }, [searchText])

  // console.log("selectedParticipants", selectedParticipants);
  // console.log("selectedParticipantId", selectedParticipantId);
  // console.log("membersList",membersList);

  const handleSelectParticipants = () => {
    setSelectedParticipantId((prevParticipant) => {
      const updatedParticipantIds = selectedRows;

      // Add new IDs (checked items) and remove unchecked ones
      const newSelectedParticipantIds = updatedParticipantIds.filter(id =>
        !prevParticipant.includes(id)  // Add only new selections
      );

      const removedParticipantIds = prevParticipant.filter(id =>
        !updatedParticipantIds.includes(id)  // Remove previously selected ones that are now unchecked
      );

      return [
        ...prevParticipant.filter(id => !removedParticipantIds.includes(id)), // Keep previously selected ones that weren't unchecked
        ...newSelectedParticipantIds // Add new selected IDs
      ];
    });
    setSelectedParticipants((prevParticipants) => {
      const newParticipants = membersList.filter((member) =>
        selectedRows.includes(member.id.toString())
      );
      return newParticipants;
    });

    // Update participantChips prop with full objects
    setParticipantChips((prevChips) => {
      const newSelectedObjects = membersList.filter((member) =>
        selectedRows.includes(member.id.toString())
      ); // Add selected objects

      const removedObjects = membersList.filter(
        (member) => !selectedRows.includes(member.id.toString())
      ); // Remove unselected objects

      return [
        ...prevChips.filter(
          (chip) => !removedObjects.some((obj) => obj.id === chip.id)
        ), // Keep existing chips that aren't in the removed list
        ...newSelectedObjects.filter(
          (obj) => !prevChips.some((chip) => chip.id === obj.id)
        ), // Add new objects that aren't already in chips
      ];
    });
    setMembersModal(false)
  };


  // Select all rows handler
  const handleSelectAll = (selectAll) => {
    if (selectAll) {
      setSelectedRows(membersList.map((row) => row.id.toString())); // Store as array of strings
      setSelectedParticipants([...membersList]); // Add all user objects
    } else {
      setSelectedRows([]);
      setSelectedParticipants([]);
    }
  };

  // console.log("setParticipantChips", participantChips)
  // Select individual row handler
  const handleRowSelect = (id, row) => {
    const rowId = id.toString(); // Ensure the id is stored as a string
    setSelectedRows((prev) => {
      if (prev.includes(rowId)) {
        setSelectedParticipants((prevParticipants) =>
          prevParticipants.filter((participant) => participant.id !== id)
        );
        return prev.filter((rowIdInArray) => rowIdInArray !== rowId);
      } else {
        setSelectedParticipants((prevParticipants) => [
          ...prevParticipants,
          row,
        ]);
        return [...prev, rowId];
      }
    });
  };


  return (
    <Modal
      show={membersModal}
      onHide={() => setMembersModal(false)}
      animation={true}
      centered
      size="xl"
      className="member-listpopup"
    >
      <Modal.Header closeButton>
        <h5 className="modal-title">View Member's List</h5>
      </Modal.Header>
      <Modal.Body>
        <div className="s-earch-and-filters d-flex gap-3 justify-content-between mb-3">
          <div className="search-filter position-relative">
            <input
              type="search"
              placeholder="Search"
              id="inputPassword2"
              className="form-control"
              // value=""
              onChange={(e) => {
                if (e.target.value) {
                  setSearchText(e.target.value);
                } else {
                  setMList(membersList);
                }
              }}
            />
            {false && 
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              //onClick={handleSearchClick}
              className="cursor-pointer"
            >
              <path
                d="M19.6973 18.3984L14.4629 13.1641C15.5957 11.7969 16.2207 10.0391 16.2207 8.125C16.2207 3.67188 12.5489 0 8.09571 0C3.60352 0 0.00976562 3.67188 0.00976562 8.125C0.00976562 12.6172 3.64258 16.25 8.09571 16.25C9.97071 16.25 11.7286 15.625 13.1348 14.4922L18.3692 19.7266C18.5645 19.9219 18.7989 20 19.0723 20C19.3067 20 19.541 19.9219 19.6973 19.7266C20.0879 19.375 20.0879 18.7891 19.6973 18.3984ZM1.88477 8.125C1.88477 4.6875 4.65821 1.875 8.13477 1.875C11.5723 1.875 14.3848 4.6875 14.3848 8.125C14.3848 11.6016 11.5723 14.375 8.13477 14.375C4.65821 14.375 1.88477 11.6016 1.88477 8.125Z"
                fill="black"
              />
            </svg>}
          </div>
          {false &&
          <div className="filter-section">
            <div className="filter-option-listing d-flex justify-content-end gap-3">
              <Dropdown className="filter-btn">
                <Dropdown.Toggle
                  variant="success"
                  id="dropdown-basic"
                >
                  All Filters
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="22"
                    height="22"
                    viewBox="0 0 22 22"
                    fill="none"
                  >
                    <path
                      d="M0 17.875C0 17.3164 0.429688 16.8438 1.03125 16.8438H3.56641C3.99609 15.4688 5.32812 14.4375 6.875 14.4375C8.37891 14.4375 9.71094 15.4688 10.1406 16.8438H20.9688C21.5273 16.8438 22 17.3164 22 17.875C22 18.4766 21.5273 18.9062 20.9688 18.9062H10.1406C9.71094 20.3242 8.37891 21.3125 6.875 21.3125C5.32812 21.3125 3.99609 20.3242 3.56641 18.9062H1.03125C0.429688 18.9062 0 18.4766 0 17.875ZM8.25 17.875C8.25 17.1445 7.60547 16.5 6.875 16.5C6.10156 16.5 5.5 17.1445 5.5 17.875C5.5 18.6484 6.10156 19.25 6.875 19.25C7.60547 19.25 8.25 18.6484 8.25 17.875ZM15.125 7.5625C16.6289 7.5625 17.9609 8.59375 18.3906 9.96875H20.9688C21.5273 9.96875 22 10.4414 22 11C22 11.6016 21.5273 12.0312 20.9688 12.0312H18.3906C17.9609 13.4492 16.6289 14.4375 15.125 14.4375C13.5781 14.4375 12.2461 13.4492 11.8164 12.0312H1.03125C0.429688 12.0312 0 11.6016 0 11C0 10.4414 0.429688 9.96875 1.03125 9.96875H11.8164C12.2461 8.59375 13.5781 7.5625 15.125 7.5625ZM16.5 11C16.5 10.2695 15.8555 9.625 15.125 9.625C14.3516 9.625 13.75 10.2695 13.75 11C13.75 11.7734 14.3516 12.375 15.125 12.375C15.8555 12.375 16.5 11.7734 16.5 11ZM20.9688 3.09375C21.5273 3.09375 22 3.56641 22 4.125C22 4.72656 21.5273 5.15625 20.9688 5.15625H11.5156C11.0859 6.57422 9.75391 7.5625 8.25 7.5625C6.70312 7.5625 5.37109 6.57422 4.94141 5.15625H1.03125C0.429688 5.15625 0 4.72656 0 4.125C0 3.56641 0.429688 3.09375 1.03125 3.09375H4.94141C5.37109 1.71875 6.70312 0.6875 8.25 0.6875C9.75391 0.6875 11.0859 1.71875 11.5156 3.09375H20.9688ZM6.875 4.125C6.875 4.89844 7.47656 5.5 8.25 5.5C8.98047 5.5 9.625 4.89844 9.625 4.125C9.625 3.39453 8.98047 2.75 8.25 2.75C7.47656 2.75 6.875 3.39453 6.875 4.125Z"
                      fill="#2D2D2D"
                    />
                  </svg>
                </Dropdown.Toggle>
                <Dropdown.Menu className="drop-down-menu">
                  <div className="dropdown-menu-filter" id="avail_menu">
                    <div className="dropdown-search">
                      <div className="dropdown-item-se pos-r"><input type="text" className="form-control-search" placeholder="Search content type" value="" />

                        <svg className="filter-searchicon" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M19.6973 18.3984L14.4629 13.1641C15.5957 11.7969 16.2207 10.0391 16.2207 8.125C16.2207 3.67188 12.5489 0 8.09571 0C3.60352 0 0.00976562 3.67188 0.00976562 8.125C0.00976562 12.6172 3.64258 16.25 8.09571 16.25C9.97071 16.25 11.7286 15.625 13.1348 14.4922L18.3692 19.7266C18.5645 19.9219 18.7989 20 19.0723 20C19.3067 20 19.541 19.9219 19.6973 19.7266C20.0879 19.375 20.0879 18.7891 19.6973 18.3984ZM1.88477 8.125C1.88477 4.6875 4.65821 1.875 8.13477 1.875C11.5723 1.875 14.3848 4.6875 14.3848 8.125C14.3848 11.6016 11.5723 14.375 8.13477 14.375C4.65821 14.375 1.88477 11.6016 1.88477 8.125Z" fill="black"></path></svg>
                      </div>
                    </div>
                    <div className="drop-multiselect">
                      <div className="dropdown-item bdr-row">
                        <div className="form-check checkallvalue">
                          <input aria-label="All" tabindex="0" type="checkbox" className="form-check-input" id="All" />
                          <label className="form-check-label" id="All" for="All">All</label>
                        </div>
                        <div className="form-check">
                          <input aria-label="County" tabindex="0" type="checkbox" className="form-check-input" id="County" />
                          <label className="form-check-label" id="County" for="County">County</label>
                        </div>
                        <div className="form-check">
                          <input aria-label="Role" tabindex="0" type="checkbox" className="form-check-input" id="Role" />
                          <label className="form-check-label" id="Role" for="Role">Role</label>
                        </div>
                        <div className="form-check">
                          <input aria-label="Offices" tabindex="0" type="checkbox" className="form-check-input" id="Offices" />
                          <label className="form-check-label" id="Offices" for="Offices">Offices</label>
                        </div>
                        <div className="form-check">
                          <input aria-label="Experiences" tabindex="0" type="checkbox" className="form-check-input" id="Experiences" />
                          <label className="form-check-label" id="Experiences" for="Experiences">Experiences</label>
                        </div>
                        <div className="form-check">
                          <input aria-label="Industry" tabindex="0" type="checkbox" className="form-check-input" id="Industry" />
                          <label className="form-check-label" id="Industry" for="Industry">Industry</label>
                        </div>
                      </div>
                    </div>
                    <div className="filter-btnrow d-flex justify-content-end gap-3" id="avl_applybtn">
                      <button type="button" className="cancelbtn">Clear filters</button>
                      <button type="submit" className="btn-primary active-page">Apply</button></div>
                  </div>
                </Dropdown.Menu>
              </Dropdown>
            </div>
          </div>}
        </div>
        <div className="table-responsive">
          <table className="table table-striped">
            <thead>
              <tr>
                <th scope="col" className="sort">
                  <input
                    type="checkbox"
                    className="form-check-input wb"
                    checked={selectedRows.length === membersList.length}
                    onChange={(e) => handleSelectAll(e.target.checked)}
                  />
                </th>
                <th scope="col" className="sort">
                  Name
                </th>
                <th scope="col" className="sort">
                  Email
                </th>
                <th scope="col" className="sort">
                  Role
                </th>
                <th scope="col" className="sort">
                  Offices
                </th>
                <th scope="col" className="sort">
                  Location
                </th>
                <th scope="col" className="sort">
                  Language
                </th>
              </tr>
            </thead>
            <tbody>
              {mList.map((row) => (
                <tr key={row.id}>
                  <td>
                    <input
                      type="checkbox"
                      className="form-check-input wb"
                      checked={selectedRows.includes(row.id.toString())}
                      //   checked={
                      //     selectedRows.includes(row.id.toString()) || 
                      //     participantChips.some(participant => participant.id === row.id.toString())
                      //   }                    
                      onChange={() => handleRowSelect(row.id, row)}
                    />
                  </td>
                  <td>{row.first_name} {row.middle_name} {row.last_name}</td>
                  <td>{row.email}</td>
                  <td>{row.Role}</td>
                  <td>{row.office_name}</td>
                  <td>{row.location}</td>
                  <td>{row.langguage}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </Modal.Body>
      <Modal.Footer className="d-flex justify-content-end">
        <div className="d-flex justify-content-end gap-3 btn-footer">
          <button className="btn-primary" onClick={() => setMembersModal(false)}>Cancel</button>
          <button className="btn-primary active-page" onClick={handleSelectParticipants}> Select</button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default ViewMembersList;
